import { OrderShippingMethod } from '@codezo/graphql';

/** Display labels for delivery/shipping methods, keyed by the enum. */
export const SHIPPING_METHOD_LABEL: Record<OrderShippingMethod, string> = {
	[OrderShippingMethod.Express]: 'Express',
	[OrderShippingMethod.Standard]: 'Standard',
};
